var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"iconBtn headerBackBtn",attrs:{"disabled":_vm.disabled},on:{"click":_vm.back}},[_c('font-awesome-icon',{attrs:{"icon":"chevron-left"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }